export const taskCenter = {
  syrw: 'Starts with the mission and ends with you',
  zjlbt: 'Biking USDT Bonus Receives Non-stop',
  wdjj: 'My bonus',
  rwsm: 'Task description',
  rwlb: 'Task list',
  jljl: 'Reward record',
  klq: 'Available for collection:',
  flzm: 'Biking Welfare Gate',
  dcjl: 'Get USDT rewards as soon as you achieve it and accompany you all the way',
  yjlq: 'One-click collection',
  lqcg: 'Received successfully',
  wdl: 'Not logged in',
  jxz: 'In progress',
  ylq: 'Received',
  rwjd: 'Task progress',
  xsrw: 'Novice task',
  hyrw: 'Contract task',
  cjrz: 'Junior Certification',
  gjrz: 'Advanced authentication',
  scbbjy: 'First coin transaction',
  schyjy: 'First contract transaction',
  sccz: 'First recharge',
  schyhz: 'First contract transfer',
  jyl: 'Trading volume',
  ylje: 'Profit amount',
  ksje: 'loss amount',
  dbkcbzj: 'Single opening margin',
  rjl: 'Deposit amount',
  dbczje: 'Single recharge amount',
  rwxq: 'Task details'

}


// WEBPACK FOOTER //
// ./src/i18n/lang/task/en.js